<div class="d-flex my-4 pt-sm-4 mb-sm-0 w-100 content_container flex-grow-1">
  <div class="flex-grow-1 d-flex flex-column gap-4 template_text">
    <div class="bg-grey d-flex flex-column">

      <h2 class="title_1 mb-0 text-grad-red">
        {{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION.CONTACT_ERROR_TITLE' | translate }}
      </h2>

      <div class="img_container d-block d-sm-none position-relative w-100">
        <img class="img-cover br-8" fill [ngSrc]="'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/post_bookings/' + locale + '-mobile-post_booking_general.svg'" [alt]="imgAltText">
      </div>
      <div>
        <p class="text_1 pb-4">{{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION.CONTACT_ERROR_TEXT' | translate }}</p>
        <a [href]="contactFormUrl" class="btn btn-lf-secondary w-fit-content d-flex gap-2 align-items-center">
          {{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION.CONTACT_ERROR_BUTTON' | translate }}
        </a>
      </div>
    </div>
  </div>

  <div class="col-4 d-none d-sm-flex justify-content-center position-sticky">
    <img class="h-fit-content img-cover aspect-ratio_1-1" src="/assets/img/post_booking/booking_accepted_{{locale}}.svg"
         height="360" width="360" [alt]="imgAltText">
  </div>
</div>
